/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 * InstructionLink component
 *
 * @author Nikolay Sviridov
 * @version 1.38.0
 * @since 1.38.0
 */

import { RefObject } from 'react';

import { TInstructionLink } from '@modules/internationalization/types/corporate';

export enum ELinkType {
    TEXT = 'TEXT',
    INFO_ICON = 'INFO_ICON'
}

export interface IInstructionLinkProps extends TInstructionLink {
    linkType: ELinkType;
    linkRef?: RefObject<HTMLAnchorElement>;
}
